module.exports = __webpack_public_path__ + "static/media/home-capacity-management.c8f4f49a.svg";